<template>
	<div>
		<div style="background-color: #F6F8FE;height: 50px;">
			 <el-button type="text" style="color: #000000;" icon="arrow-left" @click="backBtn">
				 返回
			 </el-button>
		</div>
		
		<div class="container">
			<div class="addEnterprises">
			  <el-form
			    :model="ruleForm"
			    :rules="rules1"
			    ref="ruleForm"
			    label-width="150px"
			    class="demo-ruleForm">
					
					<el-form-item prop="FileNo" label="数据类型">
					  <el-select v-model="dataTypeValue" placeholder="请选择数据类型">
							<el-option
								v-for="item in dataOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					
			    <el-form-item prop="FileNo" label="患者编号">
			      <el-input
			        placeholder="请输入患者编号 (最长16位字符)"
			        v-model="ruleForm.FileNo" :maxlength="16">
						</el-input>
			    </el-form-item>
					
			    <el-form-item prop="PatientName" label="患者姓名" >
			      <el-input
			        v-model="ruleForm.PatientName"
			        placeholder="请输入患者姓名 (最长16位字符)"
			      :maxlength="16"></el-input>
			    </el-form-item>
					
					<el-form-item prop="OrderTime" label="订单日期" >
		
						<el-date-picker
						      v-model="ruleForm.OrderTime"
						      type="date"
									:editable="false"
									value-format="yyyy-MM-dd"
						      placeholder="选择日期">
						</el-date-picker>
					</el-form-item>
							
					<el-form-item prop="Hospital" label="所属医院" >
					  <el-input
					    v-model="ruleForm.Hospital"
					    placeholder="请输入所属医院 (最长16位字符)"
							:maxlength="16"></el-input>
					</el-form-item>
					
					
					<!-- 常用值  0.625    1    1.25 -->
					<el-form-item prop="TimeInterval"   label="CT间隔" >
					  <el-input :disabled="timeIntervalDisabled"
					    v-model="ruleForm.TimeInterval"
					    placeholder="请输入CT间隔 (范围值在0.125-5,单位为mm)"
							:maxlength="6"></el-input>
					</el-form-item>
					
			    <div class="submit marleft">
			      <el-button
			        type="primary"
			        style="width:100px;height: 40px;font-size: 14px;"
			        @click="addFile"
							class="upLoadBtn">
							确认上传
						</el-button>
			    </div>
			  </el-form>
			
				<!-- 上传模型按钮 -->
				<div style="width: 500px; 
					height: 300px;margin-left: 500px;margin-top: -450px;"> 
						
					<!-- action="http://192.168.200.124:8002/ZhenYuan/UploadFile/" -->
					<!-- action="http://112.125.27.239:8002/ZhenYuan/UploadFile/" -->
					<!-- action="http://47.105.158.91:8002/ZhenYuan/UploadFile/" -->
					
					<el-upload 
						class="upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload"
						:on-preview="handlePreview"
						:on-remove="handleRemove"
						:on-success="handleSuccess"
						:before-remove="beforeRemove"
						multiple
					  :limit="1"
						:on-exceed="handleExceed"
						:file-list="fileList">
						<el-button :disabled="disabled"  size="middle" style="color: #1F6AAB;">选择文件</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle}}</div>
					</el-upload>
					
					
					<!-- 上传CT文件1按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct1upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT1"
						:on-preview="handlePreview_CT1"
						:on-remove="handleRemove_CT1"
						:on-success="handleSuccess_CT1"
						:before-remove="beforeRemove_CT1"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT1"
						:file-list="fileList_CT1">
						<el-button :disabled="disabled_CT1"  size="middle" style="color: #1F6AAB;">CT文件1</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT1}}</div>
					</el-upload>
					
					
					<!-- 上传CT文件2按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct2upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT2"
						:on-preview="handlePreview_CT2"
						:on-remove="handleRemove_CT2"
						:on-success="handleSuccess_CT2"
						:before-remove="beforeRemove_CT2"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT2"
						:file-list="fileList_CT2">
						<el-button :disabled="disabled_CT2"  size="middle" style="color: #1F6AAB;">CT文件2</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT2}}</div>
					</el-upload>
					
					
					<!-- 上传CT文件3按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct3upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT3"
						:on-preview="handlePreview_DCM"
						:on-remove="handleRemove_CT3"
						:on-success="handleSuccess_CT3"
						:before-remove="beforeRemove_CT3"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_CT3"
						:file-list="fileList_CT3">
						<el-button :disabled="disabled_CT3"  size="middle" style="color: #1F6AAB;">CT文件3</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_CT3}}</div>
					</el-upload>

										<!-- 上传DCM文件1按钮 -->
					<el-upload style="margin-top: 20px;"
						class="ct4upload-demo"
						accept=".zip"
						action="http://112.125.27.239:8004/ZhenYuan/UploadFile/"
						:before-upload="onBeforeUpload_CT3"
						:on-preview="handlePreview_DCM"
						:on-remove="handleRemove_DCM"
						:on-success="handleSuccess_DCM"
						:before-remove="beforeRemove_DCM"
						multiple
					  :limit="1"
						:on-exceed="handleExceed_DCM"
						:file-list="fileList_DCM">
						<el-button :disabled="disabled_DCM"  size="middle" style="color: #1F6AAB;">Dicom文件</el-button>
						<div slot="tip" class="el-upload__tip" style="width: 150px;">{{tipTitle_DCM}}</div>
					</el-upload>
					
				</div>
				
			
			</div>
			
			
			
			
			
				
		  </div>
		</div>
		
	</div>

</template>

<script>
import { AddFile } from "@/api/api";
export default {
  data() {
		const validateOrderTime = (rule, value, callback) => {
			// var reg = /\d{4}-\d{2}-\d{2}/;
			// if (!reg.test(value)) {
			//   callback(new Error('请选择时间'))
			// } 
			if (value.length < 1) {
			  callback(new Error('请选择时间'))
			} 
			else{
		    callback()
		  }
		}
		const validateHospital = (rule, value, callback) => {
		  if (value.length < 1) {
		    callback(new Error('请输入医院名称'))
		  }  else{
		    callback()
		  }
		}
		
		
		const validateTimeInterval = (rule, value, callback) => {
			if(!isNaN(value)){　
			  if (parseFloat(value) < 0.125) {
			    callback(new Error('请输入正确的数据值,范围值在0.125-5'))
			  } else if (parseFloat(value) > 5) {
			    callback(new Error('请输入正确的数据值,范围值在0.125-5'))
			  } else { 
	　　　　callback()
	　　		}
		　} else { 
	　　　callback(new Error('请输入正确的数据值,范围值在0.125-5'))
	　　}
		}
		
		
		
    const validateName = (rule, value, callback) => {
      if (value.length < 1) {
        callback(new Error('请输入姓名'))
      } else if (value.length > 32) {
        callback(new Error('姓名字符超限'))
      } else{
        callback()
      }
    }
    const validateFileNo = (rule, value, callback) => {
      // var reg = /^[0-9]/;
      // if (!reg.test(value))
			var reg = /^[0-9a-zA-Z]{1,}$/;
			if (!reg.test(value)) {
			  callback(new Error('请输入字母或者数字'))
			} 
			else if (value.length < 6) {
        callback(new Error('请输入最少6位患者编号'))
      } else if (value.length > 32) {
        callback(new Error('长度超限'))
      } 
			else{
        callback()
      }
    }
   
    return {
			// 数据类型    (0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')
			dataOptions: [
				{
					value: 0,
					label: '肺'
				},
				{
					value: 1,
					label: '泌尿'
				},
				{
					value: 2,
					label: '神外'
				},
				{
					value: 3,
					label: '肝胆'
				},
				{
					value: 4,
					label: '心脏'
				},
				// 新加
				{
					value: 5,
					label: '胰腺'
				},
				{
					value: 6,
					label: '甲状腺'
				},
				{
					value: 7,
					label: '耳鼻喉'
				},
				{
					value: 8,
					label: '食管'
				},
				{
					value: 9,
					label: '纵膈'
				},
								{
					value: 10,
					label: '胸外'
				},
				{
					value: 11,
					label: '普外'
				},
				{
					value: 12,
					label: '骨科'
				},
				{
					value: 13,
					label: '乳腺'
				},
				{
					value: 14,
					label: '妇科'
				},
				{
					value: 15,
					label: '胃肠'
				},
				{
					value: 16,
					label: '血管'
				},
								{
					value: 17,
					label: '腹腔'
				},
				{
					value: 18,
					label: '盆腔'
				}

			],
			dataTypeValue: "",
			tipTitle: '请选择模型文件(*.zip)',
			tipTitle_CT1: '请选择第一个CT文件(*.zip)',
			tipTitle_CT2: '请选择第二个CT文件(*.zip)',
			tipTitle_CT3: '请选择第三个CT文件(*.zip)',
			tipTitle_DCM: '请选择Dicom文件(*.zip)',
			value1: '',
			disabled: false,
			disabled_CT1: false,
			disabled_CT2: true,
			disabled_CT3: true,
			disabled_DCM: false,
			timeIntervalDisabled: true,
			fileList: [],
			fileList_CT1: [],
			fileList_CT2: [],
			fileList_CT3: [],
			fileList_DCM: [],
			CTFileUrlNum: 0,
      rules1: {
				
        FileNo: [{ required: true, trigger: 'blur', validator: validateFileNo }],
        PatientName: [{ required: true, trigger: 'blur', validator: validateName }],
				OrderTime: [{ required: true, trigger: 'blur', validator: validateOrderTime }],
				Hospital: [{ required: true, trigger: 'blur', validator: validateHospital }],
				TimeInterval: [{ required: true, trigger: 'blur', validator: validateTimeInterval }]
      },
      ruleForm: {
        PatientName: "",
        OrderTime: "",
        Hospital: "",
				FileNo: "",
				FileUrl: "",
				CTFileUrl1: "",
				CTFileUrl2: "",
				CTFileUrl3: "",
				CTFileUrlDcm: "",
				TimeInterval: "1"
      }
    };
  },
  created() {

  },
	activated(){},
  methods: {
		backBtn() {
			this.$router.push({ path: "/FileList"});
		},
		onBeforeUpload(file) {
			this.disabled = true
			console.log('onBeforeUpload');
			console.log(file);
		},
		onBeforeUpload_CT1(file) {
			this.disabled_CT1 = true
		},
		onBeforeUpload_CT2(file) {
			this.disabled_CT2 = true
			
			
		},
		onBeforeUpload_CT3(file) {
			if(this.ruleForm.CTFileUrl2.indexOf("http://") != -1){
				this.disabled_CT3 = false
			} else {
				this.disabled_CT3 = true
			}
		},
		handlePreview(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT1(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT2(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_CT3(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handlePreview_DCM(file) {
			console.log('handlePreview');
		  console.log(file);
		},
		handleExceed(files, fileList) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT1(files, fileList_CT1) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT2(files, fileList_CT2) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_CT3(files, fileList_CT3) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleExceed_DCM(files, fileList_DCM) {
		  // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			this.$message.warning(`当前限制选择 1 个文件`);
		},
		handleSuccess(response, file, fileList) {
			console.log('handleSuccess');
			console.log(response);
			console.log(response.FileUrl);
			this.ruleForm.FileUrl = response.FileUrl
			this.tipTitle = file.name
			this.disabled = true
			
		},
		
		handleSuccess_CT1(response, file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = response.FileUrl
			this.tipTitle_CT1 = file.name
			this.disabled_CT1 = true
			this.disabled_CT2 = false
			this.timeIntervalDisabled = false
			
		},
		
		handleSuccess_CT2(response, file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = response.FileUrl
			this.tipTitle_CT2 = file.name
			this.disabled_CT2 = true
			this.disabled_CT3 = false
		},
		
		handleSuccess_CT3(response, file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = response.FileUrl
			this.tipTitle_CT3 = file.name
			this.disabled_CT3 = true
		},

		handleSuccess_DCM(response, file, fileList_DCM) {
			this.ruleForm.CTFileUrlDcm = response.FileUrl
			this.tipTitle_DCM = file.name
			this.disabled_DCM = true
		},
		
		handleRemove(file, fileList) {
			this.ruleForm.FileUrl = ''
			this.tipTitle = '请选择模型文件(*.zip)'
			this.disabled = false
		},
		
		handleRemove_CT1(file, fileList_CT1) {
			this.ruleForm.CTFileUrl1 = ''
			this.tipTitle_CT1 = '请选择第一个CT文件(*.zip)'
			this.disabled_CT1 = false
		},
		
		handleRemove_CT2(file, fileList_CT2) {
			this.ruleForm.CTFileUrl2 = ''
			this.tipTitle_CT2 = '请选择第二个CT文件(*.zip)'
			this.disabled_CT2 = false
		},
		
		handleRemove_CT3(file, fileList_CT3) {
			this.ruleForm.CTFileUrl3 = ''
			this.tipTitle_CT3 = '请选择第三个CT文件(*.zip)'
			this.disabled_CT3 = false
		},

		handleRemove_DCM(file, fileList_CT3) {
			this.ruleForm.CTFileUrlDcm = ''
			this.tipTitle_DCM = '请选择Dicom文件(*.zip)'
			this.disabled_DCM = false
		},
		
		beforeRemove(file, fileList) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		
		beforeRemove_CT1(file, fileList_CT1) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_CT2(file, fileList_CT2) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_CT3(file, fileList_CT3) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		beforeRemove_DCM(file, fileList_DCM) {
		  return this.$confirm(`确定移除 ${ file.name }？`);
		},
		
		
	
		//新增管理员
    addFile() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
				  if(this.ruleForm.FileUrl == ''){
						this.$message({
							title: "error",
							message: "请选择模型文件(*.zip)",
							type: "error"
						});
					} else{
						let data = {};
						console.log(this.ruleForm.OrderTime)
						
						data.PatientName = this.ruleForm.PatientName;
						data.OrderTime = this.ruleForm.OrderTime;
						data.Hospital = this.ruleForm.Hospital;
						// data.FileNo = "BH-" + this.ruleForm.FileNo;
						data.FileNo =  this.ruleForm.FileNo;
						data.FileUrl = this.ruleForm.FileUrl;
						data.CTFileUrl1 = this.ruleForm.CTFileUrl1;
						data.CTFileUrl2 = this.ruleForm.CTFileUrl2;
						data.CTFileUrl3 = this.ruleForm.CTFileUrl3;
						data.CTFileUrlDcm = this.ruleForm.CTFileUrlDcm;
						data.TimeInterval = this.ruleForm.TimeInterval;
						data.DataType = this.dataTypeValue;
						
						
						var ctFileList=[data.CTFileUrl1, data.CTFileUrl2, data.CTFileUrl3, data.CTFileUrlDcm];
						
						console.log("ctFileList = " + ctFileList)
						
						
						for (let ctfile in ctFileList) {
							console.log("ctfile = " + ctFileList[ctfile])
							// 如果字符串不包含http://
							if (ctFileList[ctfile].indexOf("http://") != -1 ) {
								this.CTFileUrlNum++;
								console.log("this.CTFileUrlNum++ = " + this.CTFileUrlNum)
							} 
						}
					
						data.CTFileUrlNum = this.CTFileUrlNum;
						console.log(data)
						AddFile(data).then(res => {
						  console.log(res);
							
							if (JSON.stringify(res) == '{}') {
									// return true;
									this.$message({
										title: "error",
										message: "上传文件失败",
										type: "error"
									});
							} else {
								this.$message({
									title: "success",
									message: "上传文件成功",
									type: "success"
								});
									
								this.$router.push({ path: "/fileList" });
							}
							// 将CTFileUrlNum重置为0
							this.CTFileUrlNum = 0;
							
						});
					}
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    
  }
};
</script>

<style lang="scss" scoped>
.marleft {
  margin-left: 70px;
}
.upLoadBtn{
		width:168px;
		height:58px;
		background:rgba(34,107,170,1);
		border-radius:4px;
		border:1px solid rgba(83,113,255,1);
		
		font-size:16px;
		font-family:PingFangSC-Regular,PingFangSC;
		font-weight:400;
		color:rgba(255,255,255,1);
		line-height:8px;
	}
.addForm {
  height: 1000px;
}
.openaddbtn {
  height: 58px;
  text-align: center;
  background: rgba(248, 248, 248, 1);
  line-height: 58px;
}
.container {
	margin-top: 50px;
  width: 1200px;
	height: 500px;
  // padding-bottom: 30px;
	background: #FFFFFF;
}
.el-form-item {
	margin-top: 20px;
	margin-left: -75px;
  width: 450px;
}
.addEnterprises {
  margin-top: 30px;
	margin-left: 10px;
  // margin-bottom: 130px;
}
.submitBtn {
  margin-top: 50px;
}
.submit {
  margin-top: 83px;
}
.el-form-item .label {
	font-size: 24px;
	font-family:PingFangSC-Semibold,PingFangSC;
}


.el-date-editor--date{width: 330px;}
.el-upload__tip{display: inline-block;margin-left: 20px;}
</style>



// WEBPACK FOOTER //
// AddFile.vue?fc1b18dc